import {get,post} from "../index"
export const getPay={
    // 发送验证码
    getSendsms(params){
        return post('user/sendsms',params)
    },
    //  修改密码
    setPwd(params){
        return post('user/setpaypwd',params)
    },
    // 微信支付
    setWeChatPay(params){
        return post('pay/WeChatPay',params)
    },
    // 支付宝支付
    setAlipayPay(params){
        return post('pay/AlipayPay',params)
    },
    // 监听微信支付
    setWPay(params){
        return post("pay/FindOrderIsPay?OrderId="+params)
    },
    // 微信充值
    setTopUpWeChatPay(params){
        return post("pay/TopUpWeChatPay",params)
    },
    // 支付宝充值
    TopUpAlipayPay(params){
        return post('pay/TopUpAlipayPay',params)
    }
}


// WEBPACK FOOTER //
// ./src/api/http/pay.js